module.exports = __webpack_public_path__ + "static/media/lorem5.1549a674.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DynamicContent/About/peopleCompany/lorem5.png
// module id = 750
// module chunks = 0